<template lang="pug">
    li
        .header__logo
            router-link(:to="route")
                img(:src="logo" alt="" style="height:80px; margin-top:5px;")
</template>

<script>
import logo from '@img/logo.png'

export default {
    props: ['route'],
    data: function(){
        return {
            logo: logo
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/PmNavLogo.vue